import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import { api_url } from "../globalFunction/global_string";

function SelectUrlTKBG(props) {
  const [options, setOptions] = useState([]);
  const { id, name, requiredAPI, selectnet, selectunit, local_net_name, local_unit_name, parentName, selectedName } = props;


  const loadData = () => {
    let apiUrl = api_url + requiredAPI;
    const formData = new FormData();
    if (parentName === 'superSTKGB') {
      formData.append("local_net_id", selectnet);
      formData.append("local_net_name", local_net_name);
      formData.append("local_unit_id", selectunit);
      formData.append("local_unit_name", local_unit_name)
    } else if (parentName === 'superMTKGB') {
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_net_name", localStorage.getItem('login_user_net_name'));
      formData.append("local_unit_id", selectunit);
      formData.append("local_unit_name", local_unit_name)
    }
    else if (parentName === 'superNTKGB') {
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_net_name", localStorage.getItem('login_user_net_name'));
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
      formData.append("local_unit_name", localStorage.getItem('login_local_unit_name'))
    }
    else if (parentName === 'superM') {
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_net_name", localStorage.getItem('login_user_net_name'));
      formData.append("local_unit_id", selectunit);
      formData.append("local_unit_name", local_unit_name)
    } else if (parentName === 'superN') {
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_net_name", localStorage.getItem('login_user_net_name'));
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
      formData.append("local_unit_name", localStorage.getItem('login_local_unit_name'))
    }

    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        //console.log(data);
        const rows = Array.isArray(data.row) ? data.row : [data.row];
        setOptions(rows);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  useEffect(() => {
    loadData();
  }, [selectnet, local_net_name, selectunit, local_unit_name]);

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    //console.log(event.target)
    const selectedIndex = event.target.selectedIndex;
    const selectedText = event.target.options[selectedIndex].text;
    const httpIndex = selectedText.indexOf('http');
    const pureText = httpIndex > -1 ? selectedText.substring(0, httpIndex - 1) : selectedText;
    // 使用更新後的selectedName來調用props.handleUrlChange
    props.handleUrlChange({ name, value, selectedName: pureText });
  };

  return (
    <Input
      id={id}
      name={name}
      onChange={handleSelectChange}
      type='select'
      value={selectedName}
    >
      <option key="0" value="">
        請選擇
      </option>
      {options.map((option, index) => (
        <option key={option.url_addr + "_" + index} value={option.url_addr}>
          {option.url_name}-{option.url_addr}
        </option>
      ))}

    </Input>
  );
}

export default SelectUrlTKBG;
